<!-- 轮播图 -->
<template>
    <div>
        <div class="showImg">
            <!-- 轮播图片 -->
            <img @mouseover="changeInterval(true)" @mouseleave="changeInterval(false)" v-for="(item, index) in imgArr"
                :key="item.id"
                :src="item.articleImg.startsWith('/profile') ? `http://www.shx93.gov.cn/prod-api${item.articleImg}` : `http://www.shx93.gov.cn/prod-api/profile/${item.articleImg}`"
                @click="toNewsDetail(item.id)" alt="暂无图片" v-show="index === currentIndex" />
            <!-- 左侧按钮 -->
            <div @click="clickIcon('up')" class="iconDiv icon-left">
                <i class="el-icon-arrow-left" style="color: white"></i>
            </div>
            <!-- 右侧按钮 -->
            <div @click="clickIcon('down')" class="iconDiv icon-right">
                <i class="el-icon-arrow-right" style="color: white"></i>
            </div>

            <!-- 背景文字的 -->
            <div class="banner-title">
                <p class="desc_title" v-for="(item, index) in imgArr" :key="item.id" v-show="index === currentIndex">
                    {{ item.title }}</p>
            </div>
            <!-- 控制圆点 -->
            <div class="banner-circle">
                <ul>
                    <li v-for="(item, index) in imgArr" @click="changeImg(index)" :key="item.id"
                        :class="index === currentIndex ? 'active' : ''"></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            basicInfo: "",
            noticeList: [],
            sliders: [],
            firstNews: [],
            // ---------------
            currentIndex: 0,
            timer: null, //定时轮询
            imgArr: [],
            secondNavList: [],
            currentMenuIndex: null,
            mesList: [],
            ztzlBannerPic: ''
        };
    },
    created() {
        this.getSliders();
        this.startInterval();
    },
    methods: {
        // 获取轮播图
        async getSliders() {
            let res = await this.$api.nav.getJiGou();
            // console.log('工作机构轮播图',res);

            let arr = res.data.rows;
            // console.log('arr',arr);
            this.imgArr = arr.filter((current, index, arr) => {
                return current.articleImg
            })
            // this.imgArr = arr.sort((v) => v.isShowTop == 1 && v.articleImg);
            // console.log("轮播图", this.imgArr);
        },
        //开启定时器
        startInterval() {
            // 事件里定时器应该先清除再设置，防止多次点击直接生成多个定时器
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.currentIndex++;
                if (this.currentIndex > this.imgArr.length - 1) {
                    this.currentIndex = 0;
                }
            }, 2000);
        },
        // 点击控制圆点
        changeImg(index) {
            this.currentIndex = index;
            this.startInterval()
        },
        //鼠标移入移出控制
        changeInterval(val) {
            if (val) {
                clearInterval(this.timer);
            } else {
                this.startInterval();
            }
        },
        toNewsDetail(_id) {
            this.$router.push(`/newsDetail?tm=${_id}`)
            // this.$router.push({
            //   name: "routeNewsDetail",
            //   params: { id: _id },
            // });
        },
        // 点击左右箭头
        clickIcon(val) {
            if (val === "down") {
                this.currentIndex++;
                if (this.currentIndex === this.imgArr.length) {
                    this.currentIndex = 0;
                }
            } else {
                if (this.currentIndex === 0) {
                    this.currentIndex = this.imgArr.length;
                }
                this.currentIndex--;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
// --------------轮播图片-----------------
.showImg {
    position: relative;
    width: 380px;
    height: 273px;
    overflow: hidden;
    margin-top: 19px;
}

/* 轮播图片 */
.showImg img {
    width: 100%;
    height: 100%;

    &:hover {
        cursor: pointer;
    }
}

/* 箭头图标 */
.iconDiv {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    // border: 1px solid #666;
    // border-radius: 15px;
    // background-color: rgba(125, 125, 125, 0.2);
    line-height: 30px;
    text-align: center;
    font-size: 25px;
    cursor: pointer;
}

// .iconDiv:hover {
//   background-color: white;
// }

.icon-left {
    left: 10px;
}

.icon-right {
    right: 10px;
}

/* 控制圆点 */
.banner-circle {
    position: absolute;
    bottom: 8px;
    right: 0;

}

.banner-circle ul {
    margin-right: 20px;
    height: 20px;
    // width: 160px;
    display: flex;
    text-align: right;
}

.banner-circle ul li {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 5px;
    border-radius: 7px;
    // background: rgba(0, 0, 0, 0.3);
    border: 1px solid #fff;
    cursor: pointer;
}

.banner-title {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 40px;
    background: rgba(0, 0, 0, .4);
    // background-color: #000;
    padding-left: 18px;

    .desc_title {
        color: #fff !important;
        line-height: 40px;
        z-index: 200;
    }

    p {
        width: 65%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}

.active {
    background-color: rgb(255, 255, 255) !important;
}

/* 清除li前面的圆点 */
li {
    list-style-type: none;
}
</style>